import { Falcon } from '@pocketlaw/tetris/macro';
import { ListButton } from '../ListButton';
export function ESigningButton() {
    return <ListButton settingsKey="esigning" icon={<Falcon icon="pen-swirl"/>}/>;
}
